import work from './work'
import about from './about'

export default { about, work }
